import { useMutation } from "@tanstack/react-query";
import { GKButton, GKModal, GKTextField, Grid2 } from "components";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { refetchQuery } from "utils/helpers";

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  editData: any;
  telegramId: string;
}

interface FormData {
  channelName: string;
  channelId: string;
  editData: any;
  telegramId?: string;
}

const TelegramModal = ({ open, setOpen, editData, telegramId }: Props) => {
  const { id } = useParams();

  const form = useForm<FormData>({
    defaultValues: {
      channelName: "",
      channelId: "",
    },
  });

  useEffect(() => {
    form.reset({
      channelName: editData?.channelName || "",
      channelId: editData?.channelId || "",
    });
  }, [editData]);

  const { mutate: handleTelegram, isLoading } = useMutation({
    mutationFn: (data: FormData) =>
      axiosInstance.post(`/telegram-channels/`, {
        ...data,
        basket: id,
      }),
    onSuccess: (response) => {
      toast.success(response.data?.message || "Action completed successfully.");
      setOpen(false);
      form.reset();
      refetchQuery("TELEGRAM_CHANNELS");
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });

  const { mutate: updateTelegram } = useMutation({
    mutationFn: (data: FormData) =>
      axiosInstance.patch(`/telegram-channels/${telegramId}/`, {
        channelName: data.channelName,
        channelId: data.channelId,
      }),
    onSuccess: (response) => {
      toast.success(response.data?.message || "Action completed successfully.");
      setOpen(false);
      form.reset();
      refetchQuery("TELEGRAM_CHANNELS");
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again.",
      );
    },
  });

  const onSubmit = (data: FormData) => {
    if (editData) {
      updateTelegram(data);
    } else {
      handleTelegram(data);
    }
  };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={"Setup"}
      footer={
        <GKButton
          variant="contained"
          onClick={form.handleSubmit(onSubmit)}
          disabled={isLoading}
        >
          {editData ? "Update" : "Save"}
        </GKButton>
      }
    >
      <Grid2 container spacing={1}>
        <Grid2 size={6}>
          <Controller
            name="channelName"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Channel Name"
                placeholder="Channel Name"
              />
            )}
          />
        </Grid2>
        <Grid2 size={6}>
          <Controller
            name="channelId"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Channel Id"
                placeholder="Channel Id"
              />
            )}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default TelegramModal;
